import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const FixedSizeDiv = styled.div `
  height: ${(props) => `${props.customHeight || '45vh'}`};
  ${(props) => `${props.center &&
    `display: flex; justify-content: center; align-items: center;`}`};
  overflow-y: auto;
`;
export default (props) => {
    return _jsx(FixedSizeDiv, Object.assign({}, props));
};
